import styled from "styled-components";

const Wrapper = styled.div `
	display: flex;
	width: 100%;

	input {
		flex: 1;
		width: 100%;
		font-family: inherit;
		font-size: inherit;
		font-weight: inherit;
		padding: calc(2px + .2vw) calc(4px + .4vw);

		border: 0;
		outline: none;
	}

	&.rounded {
		display: flex;
		align-items:center;
		padding: calc(2px + .2vw) calc(2px + .2vw) calc(2px + .2vw) calc(8px + .8vw);
		margin-top: calc(4px + .4vw);
		background: rgba(192, 106, 255, 0.2);
		border: 1px solid rgba(255,255,255,.3);
		border-radius: 30px;

		input {
			color: white;
			background-color: transparent;
			border: none;
			padding: 0;
			font-size: 120%;

			&::placeholder {
				color: #fff7;
			}
		}
	}

`

export default Wrapper